import type { ApplicationConfig } from '@angular/core';
import { appRoutes } from './app.routes';
import { infrastructureProviders } from '@comparit/infrastructure';
import { provideAppRouter, uiProvidersConfig } from '@comparit/core';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppRouter(appRoutes),
    ...infrastructureProviders({ apiUrl: environment.apiUrl }),
    ...uiProvidersConfig,
  ],
};
